import { Component, Inject, OnInit } from '@angular/core';
import { combineLatest, distinctUntilChanged, map, Subscription } from 'rxjs';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { Logger } from 'src/app/@shared';
import { Sort } from '@angular/material/sort';
import { PageEvent } from '@angular/material/paginator';
import { Asset, AssetsService, OfferAsset, EventAssetsService, VersionAssetsService } from 'src/app/modules/standard/v1';
import { SelectionModel } from '@angular/cdk/collections';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DEFAULT_SNACKBAR_CONFIG } from 'src/app/@shared/constants/site.constants';
import { FormControl, FormGroup } from '@angular/forms';

const log = new Logger('VersionAddAssetComponent');

interface DialogData {
  versionId: string;
}

@Component({
  selector: 'app-version-add-asset',
  templateUrl: './version-add-asset.component.html',
  styleUrls: ['./version-add-asset.component.scss']
})

export class VersionAddAssetComponent implements OnInit {

  viewModel$ = combineLatest([
    this.assetsService.allVersionAssets$,
    this.assetsService.isLoading$,
    this.assetsService.VersionAssetTotalRecords$,
    this.assetsService.page$,
  ]).pipe(
    map(([allAssets, isLoading, totalRecords, page]) => {
      return { allAssets, isLoading, totalRecords, page }
    }),
  );
  flexMediaWatcher!: Subscription;
  displayedColumns = ['select', 'AssetName', 'Group', 'DateAdded', 'Type'];
  assetsList: Asset[] = [];
  selection = new SelectionModel<Asset>(true, []);
  constructor(private mediaObserver: MediaObserver,
    private assetsService: AssetsService<Asset>,
    private versionAssetService: VersionAssetsService<OfferAsset>,    
    public dialogRef: MatDialogRef<VersionAddAssetComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private matSnackBar: MatSnackBar,) { }

  ngOnInit(): void {
    log.debug('init');
    this.clearSearch();
    this.assetsService.allVersionAssets$.subscribe((data) => {
      this.assetsList = data;
    })
    const getAlias = (MediaChange: MediaChange[]) => {
      return MediaChange[0].mqAlias;
    };

    this.flexMediaWatcher = this.mediaObserver
      .asObservable()
      .pipe(
        distinctUntilChanged(
          (x: MediaChange[], y: MediaChange[]) => getAlias(x) === getAlias(y)
        ))
      .subscribe((change) => {
        if (change.some(x => x.mqAlias === 'xs')) {
          this.displayedColumns = ['select', 'AssetName'];
        }
        else if (change.some(x => x.mqAlias === 'sm')) {
          this.displayedColumns = ['select', 'AssetName', 'Type'];
        }
        else {
          this.displayedColumns = ['select', 'AssetName', 'Group', 'DateAdded', 'Type'];
        }
      });
  }

  filtersForm = new FormGroup({
    search: new FormControl(),
  });

  onSort(sortState: Sort): void {
    this.assetsService.sort(sortState);
    this.selection.clear();
  }

  onSearch(event: any) {
    this.assetsService.dialogSearch(event.target.value);
  }

  clearSearch() {
   this.filtersForm.controls.search.setValue('');
   this.assetsService.dialogSearch('');
  }

  closeDialog() {
    this.dialogRef.close();
  }


  saveData() {
    if (this.selection && this.selection.selected && this.selection.selected.length > 0) {
      let assets: any = this.selection.selected.map(x => x.Detail.Id);
      this.versionAssetService.associateAssetToVersion(assets).subscribe({
        next: () => {
          this.matSnackBar.open(`Assets are added`, 'OK', DEFAULT_SNACKBAR_CONFIG);
          this.versionAssetService.resetpage();
          this.clearSearch();
          this.versionAssetService.reload();
          this.dialogRef.close(true);
        },
        error: (error) => {
          log.error('Error adding asset to version', error);

          if (error.error.value) {
            throw new Error(error.error.value);
          } else {
            throw new Error(error.message);
          }
        }
      });
    }
  }



  onPage(pageEvent: PageEvent): void {
    this.selection.clear();
    this.assetsService.page(pageEvent);
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.assetsList.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.assetsList.forEach(row => this.selection.select(row));
  }

  public getSelectedSectionRecords() {
    return this.selection.selected;
  }

  public clearSelection() {
    this.selection.clear();
  }

}
